import React, {Component} from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import {find} from 'lodash';
import {Card, Grid, Input, Dropdown, Checkbox, Dimmer, Loader} from 'semantic-ui-react';
import {noTimeZoneShortISODate, monthAndYear} from '../../../../common/constants/datesFormat';
import {setErrorMessage, clearErrorMessage} from '../../../../common/components/form/common';
import {tabKeyCode, enterKeyCode} from '../../../../common/constants/keyCodes';
import {stopEvent} from '../../../../common/util/event';
import {Actions} from '../../../../common/actions';
import FormTemplate from './form';
import './generalInformation.scss';

class GeneralInformationTab extends Component {
  constructor(props) {
    super(props);
    this.getChassisInfo = this.getChassisInfo.bind(this);
    this.onCheckboxChange = this.onCheckboxChange.bind(this);
  }

  getAgenciesOptions() {
    const {agenciesList} = this.props;
    return agenciesList.map((item) => {
      return {'text': item.name, 'value': item.code};
    });
  }
  
  getChassisInfo(event) {
    if (!(event.keyCode === tabKeyCode || event.keyCode === enterKeyCode)) {
      return;
    }

    stopEvent(event);
    this.fetchChassis(event);
  }

  fetchChassis(event) {
    const chassis = event.target.value;
    if (!chassis) {
      return;
    }
    this.props.fetchChassisInfo(chassis, 'S');
  }

  onChangeInputField(field, event) {
    const value = event.target.value;
    this.onChangeValue(field, value);
  }

  onChangeDates(field, date) {
    const dateFormatted = date.format(noTimeZoneShortISODate);
    this.onChangeValue(field, dateFormatted);
  }

  onCheckboxChange(event, {name, value}) {
    this.onChangeValue(name, value);
  }

  onChangeValue(field, value, options) {
    this.props.setGeneralInfo(field, value);
    if (field === 'agencyCode') {
      const optionSelected = find(options, {value});
      this.props.setGeneralInfo('agencyName', optionSelected.text);
    }
  }

  renderLoader() {
    const {loading, loadingAgencies} = this.props;
    if (loading || loadingAgencies) {
      return (
        <Dimmer active inverted>
          <Loader inverted content='Cargando' />
        </Dimmer>
      );
    }
    return null;
  }

  renderLabel(width, label) {
    return (
      <Grid.Column width={width} className='skr-label'>
        <h4>{label}</h4>
      </Grid.Column>
    );
  }

  renderValue(width, value, className) {
    return (
      <Grid.Column width={width} className={className}>
        {value}
      </Grid.Column>
    );
  }

  renderFtrLabel() {
    const {formNumber, type} = this.props;
    if (!formNumber) {
      return null;
    }
    return this.renderLabel(1, `${type} No.`);
  }

  renderFtrValue() {
    const {formNumber} = this.props;
    return this.renderValue(1, formNumber, 'form-number');
  }

  render() {
    const {loadingAgencies, chassisInfo, generalInfo, isDisplayMode} = this.props;
    const productionDateFormatted = chassisInfo.productionDate ?
      moment(chassisInfo.productionDate).format(monthAndYear) : '';

    return (
      <div>
        <Card fluid raised>
          {this.renderLoader()}
          <Grid textAlign='left' className='general-information-container skr'>
            <Grid.Row>
              {this.renderLabel(2, 'Concesionario')}
              <Grid.Column width={3}>
                {generalInfo.dealerName}
              </Grid.Column>
              {this.renderLabel(1, 'Agencia')}
              <Grid.Column width={3}>
                <Dropdown selection
                  options={this.getAgenciesOptions()}
                  search
                  value={generalInfo.agencyCode}
                  disabled={loadingAgencies || isDisplayMode}
                  loading={loadingAgencies}
                  onChange={(e, {value, options}) => this.onChangeValue('agencyCode', value, options)}
                  placeholder='Seleccione Agencia'
                />
              </Grid.Column>
              {this.renderLabel(1, 'Chasis')}
              <Grid.Column width={3}>
                <Input
                  type='text'
                  required
                  value={generalInfo.chassis || ''}
                  onChange={(event) => this.onChangeInputField('chassis', event)}
                  onInvalid={(event) => setErrorMessage('Por favor, llene este campo', event)}
                  onInput={clearErrorMessage}
                  onKeyDown={this.getChassisInfo}
                  disabled={isDisplayMode}
                  placeholder='Chasis'
                  autoComplete='off'
                />
              </Grid.Column>
              {this.renderFtrLabel()}
              {this.renderFtrValue()}
            </Grid.Row>

            <Grid.Row>
              {this.renderLabel(1, 'Motor')}
              {this.renderValue(2, chassisInfo.motor)}
              {this.renderLabel(1, 'Año Modelo')}
              {this.renderValue(1, chassisInfo.modelYear)}
              {this.renderLabel(1, 'Modelo')}
              {this.renderValue(3, chassisInfo.modelName)}
              {this.renderLabel(1, 'Color')}
              {this.renderValue(2, chassisInfo.externalColor)}
              {this.renderLabel(2, 'País Origen')}
              {this.renderValue(2, chassisInfo.country)}
            </Grid.Row>

            <Grid.Row>
              <Grid.Column width={1}>
                <Checkbox
                  name='mileageMeasurement'
                  value={'KILOMETERS'}
                  checked={generalInfo.mileageMeasurement === 'KILOMETERS'}
                  onChange={this.onCheckboxChange}
                  disabled={isDisplayMode}
                  radio
                />Km
              </Grid.Column>
              <Grid.Column width={1} className='millas-container'>
                <Checkbox
                  name='mileageMeasurement'
                  value={'MILLAS'}
                  checked={generalInfo.mileageMeasurement === 'MILLAS'}
                  onChange={this.onCheckboxChange}
                  disabled={isDisplayMode}
                  radio
                />Millas
              </Grid.Column>
              <Grid.Column width={3}>
                <Input
                  type='number'
                  value={generalInfo.mileage || ''}
                  onChange={(event) => this.onChangeInputField('mileage', event)}
                  onInvalid={(event) => setErrorMessage('Por favor, llene este campo', event)}
                  onInput={clearErrorMessage}
                  disabled={isDisplayMode}
                  required={true}
                  placeholder='Kilometraje'
                  autoComplete='off'
                />
              </Grid.Column>
              {this.renderLabel(2, 'Fecha de Producción')}
              {this.renderValue(2, productionDateFormatted)}
            </Grid.Row>
          </Grid>
        </Card>

        <FormTemplate isDisplayMode={isDisplayMode} />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loadingAgencies': state.dealer.loadingAgencies,
    'agenciesList': state.dealer.agenciesList,
    'loading': state.templateSKR.loading,
    'chassisInfo': state.templateSKR.chassisInfo,
    'generalInfo': state.templateSKR.generalInfo,
    'type': state.templateSKR.type,
    'formNumber': state.templateSKR.formNumber,
  };
};

const {
  fetchChassisInfo,
  setGeneralInfo,
} = Actions;

export default connect(mapStateToProps, {
  fetchChassisInfo,
  setGeneralInfo,
})(GeneralInformationTab);
